(function() {
  "use strict";

  function normalizeVariantId(value) {
    const raw = String(value || "").trim();
    if (!raw) return "";
    const match = raw.match(/(\d+)$/);
    return match ? match[1] : raw;
  }

  function getCandidateVariantIds() {
    const selectors = document.querySelectorAll([
      '[name="id"]',
      '.product-form__variants select',
      '.variant-selectors select',
      '[data-variant-select]',
      '[data-variant-id][aria-selected="true"]',
      '[data-variant-id].selected',
      '[data-variant-id].is-selected'
    ].join(", "));
    const candidateIds = [];

    selectors.forEach((selector) => {
      if (selector.matches('[data-variant-id]')) {
        candidateIds.push(selector.getAttribute("data-variant-id"));
        return;
      }
      if ((selector.type === "radio" || selector.type === "checkbox") && !selector.checked) return;
      candidateIds.push(selector.value);
    });

    return candidateIds;
  }

  function loadPznMap(scriptId) {
    const script = document.getElementById(scriptId);
    if (!script?.textContent?.trim()) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (_error) {
      return {};
    }
  }

  function resolveVariantId(pznMap) {
    const candidates = getCandidateVariantIds();
    for (const candidate of candidates) {
      const normalized = normalizeVariantId(candidate);
      if (normalized && (normalized in pznMap)) {
        return normalized;
      }
    }
    return candidates.length > 0 ? normalizeVariantId(candidates[0]) : "";
  }

  function initPznVariant() {
    document.querySelectorAll("[data-ph-pzn]").forEach((row) => {
      if (row.dataset.initialized) return;
      row.dataset.initialized = "true";

      const valueCell = row.querySelector("[data-ph-pzn-value]");
      const mapId = row.dataset.phPznMap;
      if (!valueCell || !mapId) return;

      const pznMap = loadPznMap(mapId);
      if (Object.keys(pznMap).length === 0) return;

      const initialValue = valueCell.textContent.trim();

      function render() {
        const variantId = resolveVariantId(pznMap);
        let pzn = "";
        if (variantId && variantId in pznMap) {
          const val = pznMap[variantId];
          pzn = val != null && val !== "" ? String(val) : "";
        } else {
          pzn = initialValue;
        }
        valueCell.textContent = pzn;
      }

      function scheduleRender() {
        window.setTimeout(render, 50);
      }

      render();
      document.addEventListener("variant:change", render);
      document.addEventListener("variant:changed", render);
      document.addEventListener("change", scheduleRender, true);
      document.addEventListener("input", scheduleRender, true);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPznVariant);
  } else {
    initPznVariant();
  }

  document.addEventListener("shopify:section:load", initPznVariant);
})();
